// LineChartTimeline.jsx

import React from 'react';
import {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Legend
} from 'bizcharts';

// Define the colors for each possible line title explicitly.
// Assuming titles are: 'Student', 'Group Average', and 'Target Student'.
// Use the colors from your ComparisonDotPlot for consistency:
// Blue (#1890ff) for Student, Grey/Black-ish (#8c8c8c or similar, using a darker grey for visibility) for Group Average,
// and Red (#f5222d) for Target Student.
const COLOR_MAP = {
  Student: '#1890ff',
  'Group Average': '#8c8c8c', // Using a neutral color for Group Average
  'Target Student': '#f5222d'
};

const LineChartTimeline = ({ graphData }) => {
  const cols = {
    axisName: {
      range: [0.04, 0.95]
    },
    average: {
      min: 0,
      max: 100
    }
  };

  // Function to return the color based on the line's title
  const getColor = (title) => {
    return COLOR_MAP[title] || '#000000'; // Default to black if title not found
  };

  // Get all unique titles from the data to pass to the color prop
  const uniqueTitles = [...new Set(graphData.map(d => d.title))];

  // Map the unique titles to their explicit colors
  const customColors = uniqueTitles.map(title => getColor(title));

  return (
    <div style={{ padding: '20px' }}>
      <Chart height={400} data={graphData} scale={cols} autoFit>
        <Legend
          position='top-left'
          marker={{
            symbol: 'line',
            style: { lineWidth: 2 }
          }}
        />
        <Axis name='axisName' />
        <Axis
          name='average'
          label={{
            formatter: (val) => `${val}%`
          }}
        />
        <Tooltip
          crosshairs={{
            type: 'y'
          }}
        />
        <Geom
          type='line'
          position='axisName*average'
          size={2}

          color={['title', customColors]}
          shape='smooth'
        />
        <Geom
          type='point'
          position='axisName*average'
          size={4}
          shape='circle'

          color={['title', customColors]}
          style={{
            stroke: '#fff',
            lineWidth: 1
          }}
        />
      </Chart>
    </div>
  );
};

export default LineChartTimeline;
